// // REPLACED
export const LeaveBalanceSummary = ({ employeeLeaveCredits }) => {
  // Define the 4 brand colors in hex for inline safety
  const colorConfigs = [
    { hex: "#a855f7" }, // Purple (purple-500)
    { hex: "#22c55e" }, // Green (green-500)
    { hex: "#ef4444" }, // Red (red-500)
    { hex: "#f59e0b" }, // Amber (amber-500)
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {employeeLeaveCredits.map((credit, index) => {
        // Rotate through colors based on index
        const color = colorConfigs[index % colorConfigs.length];

        return (
          <div
            key={index}
            className="flex items-center p-4 bg-white rounded-lg shadow-md border border-gray-100"
          >
            {/* Vertical Accent Bar — Inline Style for Reliability */}
            <div
              style={{ borderLeft: `3px solid ${color.hex}`, height: "48px" }}
              className="mr-4"
            ></div>

            <div className="flex flex-col">
              <span className="text-[11px] text-gray-400 font-medium uppercase tracking-tight leading-tight">
                {credit.leaveTypeDescription || "Leave Type"}
              </span>
              {/* Count — Inline Style for Reliability */}
              <span
                className="text-2xl font-semibold mt-1"
                style={{ color: color.hex }}
              >
                {credit.remainingLeaveCredit ?? 0}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};